const mostSearched = [
  { name: 'Celular' },
  { name: 'Iphone' },
  { name: 'Notebook' },
  { name: 'Microondas' },
  { name: 'Chapinha' },
  { name: 'Secador' },
  { name: 'Brinquedo' },
  { name: 'TV' },
  { name: 'Perfume' },
  { name: 'Samsung' }
]

export default mostSearched



// WEBPACK FOOTER //
// ./src/App/Header/Search/mostSearched.js